import View from '../core/View';
import URLUtils from '../util/URLUtils';

export default class CatalogListView extends View {

    createView(model) {

        let library = model['library'];
        let baseUrl = model['baseUrl'];
        let visualTemplate = model['visualTemplate'];
        let catalogList = model['catalogList'];

        let wrapperDiv = $('<div>', {
            css: {
                'padding': '20px'
            }
        });

        let catalogListDOM = $('<div>', {
            'data-equalizer': '',
            class: 'row',
        }).appendTo(wrapperDiv);

        for (let libraryCatalog of catalogList) {

            let catalog = $('<div>', {
                class: 'col-lg-2 col-md-3 col-sm-4 col-xs-6'
            }).appendTo(catalogListDOM);

            let thumbnail = $('<div>', {
                class: 'thumbnail',
                style: `background-color: ${visualTemplate.listCatalogsBackgroundColor};`
            }).appendTo(catalog);

            let watchDiv = $('<div>', {
                'data-equalizer-watch': ''
            }).appendTo(thumbnail);

            let img = $('<img>', {
                class: 'img-responsive',
                css: {
                    'width': '100%'
                },
                src: (libraryCatalog.horizontalImage.search('http') >= 0) ? libraryCatalog.horizontalImage : URLUtils.getURL(baseUrl + libraryCatalog.horizontalImage)
            }).appendTo(watchDiv).on('load', () => {
                // Equalizer
                new Foundation.Equalizer(catalogListDOM);
            });

            let caption = $('<div>', {
                class: 'caption'
            }).appendTo(watchDiv);

            let title = $('<h3>', {
                class: '',
                style: `color: ${visualTemplate.catalogTitleColor};`,
                text: `${libraryCatalog.title}`
            }).appendTo(caption);

            let subtitle = $('<p>', {
                class: '',
                style: `color: ${visualTemplate.catalogDescriptionColor};`,
                text: `${libraryCatalog.subtitle}`
            }).appendTo(caption);

            let buttonsDiv = $('<div>', {
                class: 'caption',
                css: {
                    'margin-top': '8px'
                }
            }).appendTo(thumbnail);

            // Button Ver
            if (libraryCatalog.catalogType == 'OTHER') {
                let btnName = this.app.polyglot.t("Download");

                $('<a>', {
                    class: 'btn',
                    style: `background-color: ${visualTemplate.listCatalogsBackgroundColor}; color: ${visualTemplate.catalogButtonColor}; border: 1px solid ${visualTemplate.catalogButtonColor};`,
                    text: btnName,
                    href: (libraryCatalog.path.search('http') >= 0) ? libraryCatalog.path : URLUtils.getURL(baseUrl + libraryCatalog.path),
                    target: '_blank'
                }).appendTo(buttonsDiv);
            } else {
                let btnName = '';

                if (libraryCatalog.catalogType == 'FOLDER' || libraryCatalog.catalogType == 'INTELLIGENT_FOLDER') {
                    btnName = this.app.polyglot.t("Open");
                } else if (libraryCatalog.catalogType == 'PDF'
                        || libraryCatalog.catalogType == 'INTERACTIVE'
                        || libraryCatalog.catalogType == 'VIDEO'
                        || libraryCatalog.catalogType == 'WEB') {
                    btnName = this.app.polyglot.t("See");
                }

                let btn = $('<a>', {
                    class: 'btn',
                    style: `background-color: ${visualTemplate.listCatalogsBackgroundColor}; color: ${visualTemplate.catalogButtonColor}; border: 1px solid ${visualTemplate.catalogButtonColor};`,
                    text: btnName,
                    click: this.onViewCatalog.bind(this)
                }).prop('COILibraryCatalog', libraryCatalog)
                    .appendTo(buttonsDiv);

                img.css('cursor', 'pointer');
                img.on('click', function() { btn.trigger('click'); });
            }


            // Button Ver fuera (solo PDF)
            if (libraryCatalog.catalogType == 'PDF') {
                let btnName = this.app.polyglot.t("See outside");

                $('<a>', {
                    class: 'btn',
                    style: `background-color: ${visualTemplate.listCatalogsBackgroundColor}; color: ${visualTemplate.catalogButtonColor}; border: 1px solid ${visualTemplate.catalogButtonColor}; margin-left: 8px;`,
                    text: btnName,
                    href: (libraryCatalog.path.search('http') >= 0) ? libraryCatalog.path : URLUtils.getURL(baseUrl + libraryCatalog.path),
                    target: '_blank'
                }).appendTo(buttonsDiv);
            }

        }

        return wrapperDiv;
    }

    onViewCatalog(event) {
        let libraryCatalog = $(event.currentTarget).prop('COILibraryCatalog');
        this.app.callAction('loadLibraryCatalog', {
            'libraryCatalog': libraryCatalog
        });
        //this.app.getController('LibraryController').loadLibraryCatalog({
        //    'libraryCatalog': libraryCatalog
        //});
    }

}